// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import BackgroundSlider from "react-background-slider";

import HeaderSearch from "../HeaderSearch";

type $Props = {
  classes: Object,
  backgroundImage: string,
  backgroundImages?: Array<string>,
  isCanadian: Function,
};

const FullWidthBgWithSearch = React.memo((props: $Props) => {
  const { classes, backgroundImage, backgroundImages, isCanadian } = props;
  const innerPortion = (
    <div className={classes.rootContent}>
      <Typography type="title" className={classes.headerTitle}>
        Search For Homes
      </Typography>
      <div className={classes.searchContainer}>
        <HeaderSearch showColorButtons={true} isCanadian={isCanadian()} />
      </div>
    </div>
  );

  if (backgroundImages && backgroundImages.length > 1) {
    return (
      <div className={classes.root}>
        <BackgroundSlider
          images={backgroundImages}
          duration={5}
          transition={2}
        />
        <div className={classes.backgroundImagesOverlay}>{innerPortion}</div>
      </div>
    );
  }

  return (
    <div
      className={classes.root}
      style={{
        background: `linear-gradient(rgba(20, 20, 20, 0.4), rgba(20, 20, 20, 0.4)), url(${backgroundImage}) center/cover no-repeat`,
      }}
    >
      {innerPortion}
    </div>
  );
});

const styles = (theme) => {
  return {
    root: {
      display: "flex",
      position: "relative",
      flexFlow: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      minHeight: "500px",
    },
    rootContent: {
      display: "flex",
      position: "relative",
      flexFlow: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      marginTop: theme.spacing.unit * 6,
      zIndex: theme.zIndex.buttonChildren,
    },
    backgroundImagesOverlay: {
      backgroundColor: "#00000050",
      width: "100%",
      minHeight: "500px",
    },
    searchContainer: {
      position: "relative",
      width: "100%",
      maxWidth: "640px",
      padding: theme.spacing.unit * 2,
      backgroundColor: theme.colors.primary["500"],
    },
    headerTitle: {
      margin: "16px auto",
      color: "white",
      textAlign: "center",
    },
  };
};

export default withGlobalContext(withStyles(styles)(FullWidthBgWithSearch));
